'use client';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({ error }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div className="flex min-h-[50vh] flex-col items-center justify-center px-4 text-center">
          <h2 className="mb-4 text-2xl font-bold text-gray-900">Something went wrong!</h2>
          <p className="mb-8 text-gray-600">
            We apologize for the inconvenience. Please try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-full bg-black px-6 py-2 text-white transition-colors hover:bg-gray-800"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
